import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../App/State/Slices/SelectedCareersClientSlice";
import JobGroupsTableCell from "./Components/JobGroupsTableCell";
import SortableTable from "../../App/Components/Table/SortableTable";
import { getJobGroups } from "./JobGroupsService";

function JobGroupsPage({ jobType }) {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    autocomplete: {
      width: "35%",
      paddingBottom: "20px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    hint: {
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      marginTop: "auto",
      marginBottom: "auto",
      marginLeft: "auto",
      marginRight: "auto",
      width: "300px",
      height: "300px",
      fontSize: "32px",
      textAlign: "center",
      color: "rgba(0,0,0,.6)",
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);

  const columns = [
    { label: "Name", propName: "name" },
    { label: "ATS Name", propName: "atsname" },
  ];

  useEffect(() => {
    if (selectCareersClient !== null) {
      getJobGroups(selectCareersClient.id, jobType).then((response) => {
        setTableData(response);
        setLoading(false);
      });
    }
  }, [selectCareersClient]);

  return (
    <>
      <div className={classes.root}>
        {selectCareersClient === null ? (
          <div className={classes.hint}>
            <span>Select a client</span>
          </div>
        ) : (
          <Grid container spacing={1}>
            <SortableTable
              columns={columns}
              tableData={tableData}
              rowComponent={JobGroupsTableCell}
              loading={loading}
              setTableData={setTableData}
              defaultSortIndex={1}
            />
          </Grid>
        )}
      </div>
    </>
  );
}

export default JobGroupsPage;
